// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { ZahllaufDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDetachRechnungenVonZahllauf(): (
  requestBody: ZahllaufDaten
) => Promise<void> {
  const getAPI = useGetApi();
  return useCallback(
    async (requestBody) =>
      (await getAPI()).zahllaeufe.detachRechnungenVonZahllauf({ requestBody }),
    [getAPI]
  );
}
